export default function formatNumberFullSize(fullWidthNum) {
  return fullWidthNum.replace(/[\uFF10-\uFF19]/g, function(m) {
    return String.fromCharCode(m.charCodeAt(0) - 0xfee0)
  })
}
